import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import { useAtomValue } from "jotai";
import { FaPlus } from "react-icons/fa";
import { BsThreeDotsVertical } from "react-icons/bs";
import DataTable from "react-data-table-component";
import { Image } from "react-bootstrap";
import { formatDistanceToNow } from "date-fns";
import showToast from "../../../helpers/showToast";
import uploadImage from "../../../helpers/uploadImage";
import Loader from "../../../components/Loader";
import { deleteRecord, get, put } from "../../../server";
import { loggedInUser } from "../../../utils/store";
import {
  ALLTEAMOWNERS,
  PRIORITY,
  TEAM_BRANDING,
  TEAMDETAIL,
  THEME_CHANGE,
  THEME_GET,
  TOGGLE_TEAM_FUNCTION_VISIBILITY,
  USER,
} from "../../../utils/constants/apiUrl";
import baseURL from "../../../utils/constants/baseUrl";
import { CardBackGroundImages } from "../../../utils/data/CardFunctionsData";
import cardIcon from "../../../assets/images/function_page_icons/cardIcon.svg";
import paymentIcon from "../../../assets/images/function_page_icons/paymentIcon.svg";
import emergencyIcon from "../../../assets/images/function_page_icons/emergencyIcon.svg";
import customIcon from "../../../assets/images/function_page_icons/customIcon.svg";
import fileUploadIcon from "../../../assets/images/function_page_icons/fileUploadIcon.svg";
import formbuilderIcon from "../../../assets/images/function_page_icons/formbuilderIcon.svg";
import memoryIcon from "../../../assets/images/function_page_icons/memoryIcon.svg";
import medicalIcon from "../../../assets/images/function_page_icons/medicalIcon.svg";
import dummyImage from "../../../assets/images/global_icons/dummyimage.svg";
import formatPhoneNumber from "../../../helpers/formatPhoneNumber";
import ConfirmationModal from "../../../components/Modals/ConfirmationModal";

const customerFunctions = [
  {
    id: "digital-card",
    functionType: "card",
    icon: cardIcon,
    name: "Digital Card",
    description: "Create Your Personal & Business Card",
  },
  {
    id: "payment-service",
    functionType: "payment",
    icon: paymentIcon,
    name: "Payment Service",
    description: "Link Your Payment Service Account",
  },
  {
    id: "emergency-contact",
    functionType: "emergency_contact",
    icon: emergencyIcon,
    name: "Emergency Contact",
    description: "For Emergency Purpose",
  },
  {
    id: "custom-url",
    functionType: "custom_url",
    icon: customIcon,
    name: "Custom URL's",
    description: "Create Your Custom URL's",
  },
  {
    id: "file-upload-url",
    functionType: "file_upload",
    icon: fileUploadIcon,
    name: "File Upload URL",
    description: "Upload and Share documents",
  },
  {
    id: "lead-builder",
    functionType: "form_builder",
    icon: formbuilderIcon,
    name: "Lead Builder",
    description: "For Lead Generation",
  },
  {
    id: "memory",
    functionType: "memory",
    icon: memoryIcon,
    name: "Memory",
    description: "Create Your Audio & video Link",
  },
  {
    id: "medical-id",
    functionType: "medical_id",
    icon: medicalIcon,
    name: "Medical ID",
    description: "Create Your Medical ID",
  },
];

const imageUrl = (image) =>
  !image || image.startsWith("http") || image.startsWith("data:")
    ? image
    : baseURL.PUBLIC_URL + image;

const ColorInput = ({ id, label, value, onChange }) => (
  <div className="mb-4">
    <label className="formColorLabel mb-2 d-block" htmlFor={id}>{label}</label>
    <label htmlFor={id} style={{ display: "inline-flex", alignItems: "center", gap: 10, padding: "6px 14px 6px 6px", borderRadius: 10, border: "1.5px solid #e0e0e0", background: "#fafafa", cursor: "pointer", boxShadow: "0 1px 4px rgba(0,0,0,0.07)" }}>
      <span style={{ width: 36, height: 36, borderRadius: 7, background: value || "#ffffff", border: "1px solid rgba(0,0,0,0.12)", position: "relative", overflow: "hidden" }}>
        <input id={id} type="color" value={/^#[0-9a-f]{6}$/i.test(value) ? value : "#ffffff"} onChange={(event) => onChange(event.target.value)} style={{ opacity: 0, position: "absolute", inset: 0, width: "100%", height: "100%", cursor: "pointer" }} />
      </span>
      <input aria-label={`${label} hex value`} type="text" value={value} placeholder="#000000" maxLength={7} onChange={(event) => onChange(event.target.value)} onClick={(event) => event.stopPropagation()} style={{ fontFamily: "monospace", fontSize: 13, fontWeight: 600, color: "#333", border: 0, outline: 0, background: "transparent", width: 80 }} />
    </label>
  </div>
);

const ManageCustomer = () => {
  const { userId } = useParams();
  const loggedUser = useAtomValue(loggedInUser);
  const [enabledFunctions, setEnabledFunctions] = useState({});
  const [loadingFunctions, setLoadingFunctions] = useState(true);
  const [updatingFunction, setUpdatingFunction] = useState(null);
  const [loadingBranding, setLoadingBranding] = useState(false);
  const [loadingMembers, setLoadingMembers] = useState(false);
  const [teamMembers, setTeamMembers] = useState([]);
  const [membersPerPage, setMembersPerPage] = useState(10);
  const [membersPage, setMembersPage] = useState(1);
  const [activeCustomerTab, setActiveCustomerTab] = useState("functions");
  const [memberToRemove, setMemberToRemove] = useState(null);
  const [showRemoveMemberModal, setShowRemoveMemberModal] = useState(false);
  const [savingBranding, setSavingBranding] = useState(false);
  const [teamId, setTeamId] = useState(null);
  const [useCustomTheme, setUseCustomTheme] = useState(false);
  const [themeColor, setThemeColor] = useState("");
  const [buttonColor, setButtonColor] = useState("");
  const [cardColor, setCardColor] = useState("");
  const [logo, setLogo] = useState("");
  const [logoPreview, setLogoPreview] = useState("");
  const [cardBackgroundImage, setCardBackgroundImage] = useState("");
  const [logoUploading, setLogoUploading] = useState(false);
  const [cardBgUploading, setCardBgUploading] = useState(false);
  const logoFileRef = useRef(null);
  const cardBgFileRef = useRef(null);
  const token = loggedUser?.token || null;
  // This screen lives inside the super-admin-only route tree. Do not gate the
  // controls a second time from hydrated client state; that could incorrectly
  // disable them while the authenticated user atom is being restored.
  const canManageFunctionVisibility = true;

  useEffect(() => {
    const loadBranding = async () => {
      setLoadingBranding(true);
      const ownersResponse = await get(ALLTEAMOWNERS, token);
      const owner = ownersResponse.status ? ownersResponse.data?.find((item) => String(item.id) === String(userId)) : null;
      const selectedTeamId = owner?.teams?.id;
      if (!selectedTeamId) {
        showToast(false, ownersResponse.message || "The selected customer does not have a team.");
        setLoadingFunctions(false);
        setLoadingBranding(false);
        return;
      }
      setTeamId(selectedTeamId);
      setLoadingMembers(true);
      const [response, settingsResponse, membersResponse] = await Promise.all([
        get(`${THEME_GET}?user_id=${encodeURIComponent(userId)}`, token),
        get(`${PRIORITY}?team_id=${selectedTeamId}`, token),
        get(`${TEAMDETAIL}/${selectedTeamId}`, token),
      ]);
      const theme = response?.status ? response.data || {} : {};
      const branding = theme.team || owner.teams || {};
      setUseCustomTheme(Boolean(theme.theme_color));
      setThemeColor(theme.theme_color || "");
      setButtonColor(theme.button_color || branding.button_color || "");
      setCardColor(branding.card_color || "");
      setLogo(branding.logo || "");
      setLogoPreview(imageUrl(branding.logo || ""));
      setCardBackgroundImage(branding.card_background_image || "");
      if (!response?.status) {
        showToast(false, response?.message || "Customer branding could not be loaded.");
      }
      if (settingsResponse.status) {
        const settings = Array.isArray(settingsResponse.data)
          ? settingsResponse.data
          : settingsResponse.data?.data || [];
        setEnabledFunctions(
          Object.fromEntries(
            customerFunctions.map(({ id, functionType }) => {
              const setting = settings.find(
                (item) => item.function_type === functionType
              );
              return [id, setting ? Number(setting.is_member_visible) === 1 : true];
            })
          )
        );
      } else {
        setEnabledFunctions(
          Object.fromEntries(customerFunctions.map(({ id }) => [id, true]))
        );
        showToast(false, settingsResponse.message || "Function settings could not be loaded.");
      }
      if (membersResponse?.status) {
        const members = Array.isArray(membersResponse.data?.team_members)
          ? membersResponse.data.team_members
          : [];
        setTeamMembers(
          members.map((member) => ({
            ...(member.user_data || {}),
            job_title: member.job_title ?? member.user_data?.job_title ?? "",
            last_active_at:
              member.last_active_at ??
              member.last_activity_at ??
              member.last_active ??
              member.user_data?.last_active_at ??
              member.user_data?.last_activity_at ??
              member.user_data?.last_active ??
              null,
            latest_qrcode_share_activity:
              member.latest_qrcode_share_activity ??
              member.user_data?.latest_qrcode_share_activity ??
              null,
            latest_nfc_activity:
              member.latest_nfc_activity ??
              member.user_data?.latest_nfc_activity ??
              null,
            team_id: member.team_id || selectedTeamId,
            user_id: member.user_id,
            is_admin: member.is_admin,
            member_id: member.id,
          }))
        );
      } else {
        setTeamMembers([]);
        showToast(false, membersResponse?.message || "Team members could not be loaded.");
      }
      setLoadingFunctions(false);
      setLoadingBranding(false);
      setLoadingMembers(false);
    };
    loadBranding();
  }, [token, userId]);

  const toggleFunction = async (functionId, functionType) => {
    if (!canManageFunctionVisibility || !teamId || updatingFunction) return;
    const nextValue = !enabledFunctions[functionId];
    setUpdatingFunction(functionId);
    setEnabledFunctions((current) => ({ ...current, [functionId]: nextValue }));
    const response = await put(
      TOGGLE_TEAM_FUNCTION_VISIBILITY,
      {
        team_id: Number(teamId),
        function_type: functionType,
        is_member_visible: nextValue ? 1 : 0,
      },
      token
    );
    if (!response?.status) {
      setEnabledFunctions((current) => ({ ...current, [functionId]: !nextValue }));
      showToast(false, response.message || "Function visibility could not be updated.");
    }
    setUpdatingFunction(null);
  };

  const handleImageUpload = async (event, imageType, setUploading, onSuccess) => {
    const file = event.target.files?.[0];
    if (!file) return;
    setUploading(true);
    const response = await uploadImage(imageType, file, token);
    if (response.status && response.data) onSuccess(response.data, file);
    else showToast(false, response.message || "Image upload failed.");
    setUploading(false);
    event.target.value = "";
  };

  const saveBranding = async () => {
    if (!teamId) return showToast(false, "The selected customer does not have a team.");
    const invalidColor = [["Theme color", themeColor], ["Card color", cardColor], ["Button color", buttonColor]].find(([, value]) => value && !/^#[0-9a-f]{6}$/i.test(value));
    if (invalidColor) return showToast(false, `${invalidColor[0]} must be a six-digit hex color.`);
    setSavingBranding(true);
    const ownerId = Number(userId);
    const [themeResponse, brandingResponse] = await Promise.all([
      put(THEME_CHANGE, {
        theme_color: useCustomTheme ? themeColor || null : null,
        button_color: useCustomTheme ? buttonColor || null : null,
        user_id: ownerId,
      }, token),
      put(TEAM_BRANDING(teamId), {
        logo: logo || null,
        card_logo_shape: "circle",
        card_background_image: cardBackgroundImage || null,
        card_color: cardColor || null,
        user_id: ownerId,
      }, token),
    ]);
    const success = Boolean(themeResponse?.status && brandingResponse?.status);
    const message = !themeResponse?.status
      ? themeResponse?.message
      : brandingResponse?.message;
    showToast(success, message || (success ? "Customer branding saved successfully." : "Customer branding could not be saved."));
    setSavingBranding(false);
  };

  const removeLogo = async () => {
    if (!teamId || savingBranding) return;
    const previousLogo = logo;
    const previousPreview = logoPreview;
    setLogo("");
    setLogoPreview("");
    setSavingBranding(true);
    const response = await put(
      TEAM_BRANDING(teamId),
      { logo: null, user_id: Number(userId) },
      token
    );
    if (!response?.status) {
      setLogo(previousLogo);
      setLogoPreview(previousPreview);
      showToast(false, response?.message || "Logo could not be removed.");
    }
    setSavingBranding(false);
  };

  const clearCardBackground = async () => {
    if (!teamId || savingBranding) return;
    const previousBackground = cardBackgroundImage;
    setCardBackgroundImage("");
    setSavingBranding(true);
    const response = await put(
      TEAM_BRANDING(teamId),
      { card_background_image: null, user_id: Number(userId) },
      token
    );
    if (!response?.status) {
      setCardBackgroundImage(previousBackground);
      showToast(false, response?.message || "Card background could not be cleared.");
    }
    setSavingBranding(false);
  };

  const getActivityTime = (activity) => {
    const value = activity?.created_at;
    if (!value) return "-";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    return date.toLocaleString([], {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const memberColumns = [
    {
      name: "Name",
      width: "14%",
      cell: (row) => (
        <div className="profileWrapper w-100 h-100">
          <Image
            src={row.profile_image ? imageUrl(row.profile_image) : dummyImage}
            roundedCircle
            width="50px"
            height="50px"
            onError={(event) => { event.currentTarget.src = dummyImage; }}
          />
          <p className="globalName mb-0">{`${row.first_name || ""} ${row.last_name || ""}`.trim() || "-"}</p>
        </div>
      ),
    },
    { name: "Email", width: "13%", cell: (row) => <a href={`mailto:${row.email}`} className="globalDetail">{row.email || "-"}</a> },
    { name: "Job Title", width: "10%", cell: (row) => <p className="globalDetail">{row.job_title || "-"}</p> },
    {
      name: "Last Active",
      width: "12%",
      cell: (row) => row.last_active_at ? (
        <div className="globalDetail">
          <div className="d-flex align-items-center gap-2"><span style={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: "#20b994" }} />Active</div>
          <small className="text-muted">{formatDistanceToNow(new Date(row.last_active_at), { addSuffix: true })}</small>
        </div>
      ) : (
        <div className="globalDetail"><div className="d-flex align-items-center gap-2"><span style={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: "#8b949e" }} />Inactive</div><small className="text-muted">Invite pending</small></div>
      ),
    },
    { name: "QR Scan", width: "8%", cell: (row) => <p className="globalDetail">{getActivityTime(row.latest_qrcode_share_activity)}</p> },
    { name: "NFC Scan", width: "8%", cell: (row) => <p className="globalDetail">{getActivityTime(row.latest_nfc_activity)}</p> },
    {
      name: "Phone Number",
      width: "12%",
      cell: (row) => row.phone_number ? <a className="globalDetail" href={`tel:${row.country_phone ? `+${row.country_phone} ` : ""}${row.phone_number}`}>{row.country_phone ? `+${row.country_phone} ` : ""}{formatPhoneNumber(row.phone_number)}</a> : <p className="globalDetail">-</p>,
    },
    { name: "City, Country", width: "9%", cell: (row) => <p className="globalDetail">{[row.city, row.country].filter(Boolean).join(", ") || "-"}</p> },
    { name: "Is Admin", width: "7%", cell: (row) => <p className="globalDetail">{row.is_admin === true || Number(row.is_admin) === 1 ? "Yes" : "No"}</p> },
    {
      name: "Action",
      width: "7%",
      right: true,
      ignoreRowClick: true,
      button: true,
      cell: (row) => (
        <div className="action">
          <button className="btn customActionDropdown dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"><BsThreeDotsVertical className="globalVerticalThreeDots" /></button>
          <ul className="customActionDropdownMenu dropdown-menu dropdown-menu-end">
            <li><Link className="dropdown-item" to={`/allTeamOwners/teamDetail/${teamId}/editTeamMember/${row.user_id}`}>Edit</Link></li>
            <li>
              <span
                className="dropdown-item text-danger"
                onClick={() => {
                  setMemberToRemove(row);
                  setShowRemoveMemberModal(true);
                }}
                role="button"
              >
                Remove from team
              </span>
            </li>
          </ul>
        </div>
      ),
    },
  ];

  const membersTotalPages = Math.ceil(teamMembers.length / membersPerPage);
  const paginatedTeamMembers = teamMembers.slice(
    (membersPage - 1) * membersPerPage,
    membersPage * membersPerPage
  );

  const closeRemoveMemberModal = () => {
    setShowRemoveMemberModal(false);
    setMemberToRemove(null);
  };

  const removeMemberFromTeam = async () => {
    const memberUserId = memberToRemove?.user_id || memberToRemove?.id;
    const memberTeamId = memberToRemove?.team_id || teamId;
    if (!memberUserId || !memberTeamId) return;

    const response = await deleteRecord(
      `${USER}/${memberUserId}?team_id=${memberTeamId}`,
      token
    );
    showToast(response?.status, response?.message);
    if (response?.status) {
      const remainingMembers = teamMembers.filter(
        (member) => String(member.user_id || member.id) !== String(memberUserId)
      );
      setTeamMembers(remainingMembers);
      const remainingPages = Math.max(
        1,
        Math.ceil(remainingMembers.length / membersPerPage)
      );
      setMembersPage((page) => Math.min(page, remainingPages));
    }
    closeRemoveMemberModal();
  };

  return (
    <div className="">
      <div className="page_Header">
        <div className="d-flex justify-content-between align-items-md-center align-items-initial flex-md-row flex-column gap-3 mb-3">
          <div className="heading">
            <h1 className="pageTitle">
              <Link
                to="/allTeamOwners"
                className="mobileViewWrapper"
                style={{ color: "var(--primary_text_color)" }}
              >
                Team Owners
              </Link>
              {` > Manage Customer`}
            </h1>
          </div>
        </div>
      </div>
      <div className="position-relative">
        {activeCustomerTab === "team-members" && (
          <Link
            className="btn btn-primary position-absolute manage-customer-add-member"
            to={`/allTeamOwners/teamDetail/${teamId}/addTeamMember`}
          >
            Add Member
          </Link>
        )}
        <Tabs
          activeKey={activeCustomerTab}
          onSelect={(key) => setActiveCustomerTab(key || "functions")}
          id="manage-customer-tabs"
          className="mb-3 customTabs"
          transition={false}
        >
        <Tab eventKey="functions" title="Functions">
          {loadingFunctions ? <Loader /> : <div className="row g-3 mt-1">
            {customerFunctions.map(({ id, functionType, icon, name, description }) => (
              <div className="col-12 col-md-6" key={id}>
                <div
                  className="d-flex align-items-center justify-content-between h-100 p-3 border rounded bg-white"
                  style={{ minHeight: "88px" }}
                >
                  <div className="d-flex align-items-center pe-3">
                    <img
                      alt=""
                      className="flex-shrink-0 me-3"
                      src={icon}
                      style={{ height: "48px", objectFit: "contain", width: "48px" }}
                    />
                    <div>
                      <h5 className="mb-1">{name}</h5>
                      <p className="mb-0 text-muted">{description}</p>
                    </div>
                  </div>
                  <div className="form-check form-switch flex-shrink-0 mb-0">
                    <input
                      aria-label={`${enabledFunctions[id] ? "Disable" : "Enable"} ${name}`}
                      checked={enabledFunctions[id]}
                      className="form-check-input"
                      disabled={
                        !canManageFunctionVisibility || Boolean(updatingFunction)
                      }
                      onChange={() => toggleFunction(id, functionType)}
                      role="switch"
                      type="checkbox"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>}
        </Tab>
        <Tab eventKey="branding" title="Branding">
          {loadingBranding ? <Loader /> : (
            <div className="bg-white border rounded p-3 p-md-4 mt-3">
              <section className="mb-4">
                <h4 className="mb-3">Choose Your Theme</h4>
                <div className="theme-radio" style={{ maxWidth: 240 }}>
                  <div className="form-check">
                    <input id="adminCustomTheme" className="form-check-input" type="checkbox" checked={useCustomTheme} onChange={(event) => setUseCustomTheme(event.target.checked)} />
                    <label className="form-check-label" htmlFor="adminCustomTheme">Custom theme</label>
                  </div>
                </div>
                {useCustomTheme && <div className="mt-3"><ColorInput id="adminThemeColor" label="Theme Color" value={themeColor} onChange={setThemeColor} /></div>}
              </section>
              <hr className="my-4" />
              <section>
                <h5 className="mb-3">Branding Assets</h5>
                <div className="mb-4">
                  <label className="formColorLabel mb-2 d-block">Logo</label>
                  <div className="d-flex align-items-center gap-3">
                    <div style={{ width: 80, height: 80, borderRadius: 12, border: "2px dashed #ccc", background: "#f9f9f9", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", flexShrink: 0 }}>
                      {logoPreview || logo ? <img src={logoPreview || imageUrl(logo)} alt="Team logo" style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : <FaPlus style={{ color: "#bbb", fontSize: 22 }} />}
                    </div>
                    <div>
                      <button className="btn btn-outline-secondary btn-sm" type="button" disabled={logoUploading} onClick={() => logoFileRef.current?.click()}>{logoUploading ? "Uploading…" : "Upload Logo"}</button>
                      {(logo || logoPreview) && <button className="btn btn-link btn-sm ms-2" type="button" disabled={savingBranding} onClick={removeLogo}>Remove</button>}
                      <p className="mt-1 mb-0 text-muted" style={{ fontSize: 12 }}>PNG, JPG or SVG recommended</p>
                    </div>
                  </div>
                  <input ref={logoFileRef} type="file" accept="image/*" hidden onChange={(event) => handleImageUpload(event, "card_logo", setLogoUploading, (path, file) => { setLogo(path); setLogoPreview(URL.createObjectURL(file)); })} />
                </div>
                <div className="mb-4">
                  <label className="formColorLabel mb-2 d-block">Card Background Image</label>
                  <div className="d-flex flex-wrap gap-2">
                    {CardBackGroundImages.map((background) => (
                      <button key={background.id} type="button" aria-label={`Select background ${background.id}`} onClick={() => setCardBackgroundImage(background.img)} style={{ width: 72, height: 48, padding: 0, borderRadius: 8, border: cardBackgroundImage === background.img ? "4px solid #529e83" : "2px solid #ddd", overflow: "hidden", background: "none" }}>
                        <img src={imageUrl(background.img)} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                      </button>
                    ))}
                    {cardBackgroundImage && !CardBackGroundImages.some((background) => background.img === cardBackgroundImage) && <div style={{ width: 72, height: 48, borderRadius: 8, border: "4px solid #529e83", overflow: "hidden" }}><img src={imageUrl(cardBackgroundImage)} alt="Uploaded card background" style={{ width: "100%", height: "100%", objectFit: "cover" }} /></div>}
                    <button type="button" disabled={cardBgUploading} onClick={() => cardBgFileRef.current?.click()} style={{ width: 72, height: 48, borderRadius: 8, border: "2px dashed #aaa", background: "transparent", fontSize: 11 }}>{cardBgUploading ? "Uploading…" : <><FaPlus /><br />Upload</>}</button>
                    {cardBackgroundImage && <button type="button" className="btn btn-outline-danger btn-sm" disabled={savingBranding} onClick={clearCardBackground}>Clear</button>}
                  </div>
                  <input ref={cardBgFileRef} type="file" accept="image/*" hidden onChange={(event) => handleImageUpload(event, "card_background", setCardBgUploading, (path) => setCardBackgroundImage(path))} />
                </div>
                <ColorInput id="adminCardColor" label="Card Color" value={cardColor} onChange={setCardColor} />
                <ColorInput id="adminButtonColor" label="Button Color" value={buttonColor} onChange={setButtonColor} />
              </section>
              <button className="btn btn-primary" onClick={saveBranding} type="button" disabled={savingBranding || logoUploading || cardBgUploading || !teamId}>{savingBranding ? "Saving…" : "Submit"}</button>
            </div>
          )}
        </Tab>
        <Tab eventKey="team-members" title={`Team Members (${teamMembers.length})`}>
          {loadingMembers ? <Loader /> : (
            <div className="mt-3">
              <div className="default-list-table bg-white manage-customer-members-table">
                <DataTable
                  columns={memberColumns}
                  data={paginatedTeamMembers}
                  persistTableHead
                  noDataComponent="No team members found."
                />
                <div className="d-flex justify-content-center align-items-center p-3 flex-wrap gap-4 border-top bg-white">
                  <div className="d-flex align-items-center gap-2">
                    <span className="globalDetail">Rows per page:</span>
                    <select
                      aria-label="Rows per page"
                      className="form-select"
                      style={{ width: "auto", padding: "6px 35px 6px 12px" }}
                      value={membersPerPage}
                      onChange={(event) => {
                        setMembersPerPage(Number(event.target.value));
                        setMembersPage(1);
                      }}
                    >
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </select>
                  </div>
                  <nav aria-label="Team members pagination">
                    <ul className="pagination mb-0">
                      <li className={`page-item ${membersPage === 1 ? "disabled" : ""}`}>
                        <button className="page-link" type="button" onClick={() => setMembersPage((page) => page - 1)} style={{ color: "#58a388", padding: "8px 16px", minWidth: 45 }}>&laquo; Previous</button>
                      </li>
                      {Array.from({ length: membersTotalPages }, (_, index) => index + 1).map((page) => (
                        <li className={`page-item ${membersPage === page ? "active" : ""}`} key={page}>
                          <button
                            className="page-link"
                            type="button"
                            onClick={() => setMembersPage(page)}
                            style={{
                              backgroundColor: membersPage === page ? "#58a388" : "#ffffff",
                              borderColor: membersPage === page ? "#58a388" : "#dee2e6",
                              color: membersPage === page ? "#ffffff" : "#58a388",
                              padding: "8px 16px",
                              minWidth: 45,
                            }}
                          >
                            {page}
                          </button>
                        </li>
                      ))}
                      <li className={`page-item ${membersPage === membersTotalPages || membersTotalPages === 0 ? "disabled" : ""}`}>
                        <button className="page-link" type="button" onClick={() => setMembersPage((page) => page + 1)} style={{ color: "#58a388", padding: "8px 16px", minWidth: 45 }}>Next &raquo;</button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          )}
        </Tab>
        </Tabs>
      </div>
      <ConfirmationModal
        show={showRemoveMemberModal}
        handleCloseModal={closeRemoveMemberModal}
        handleConfirmDelete={removeMemberFromTeam}
        confirmTitle="team member"
        isRemoveMemberMessage
      />
      <style type="text/css">{`
        .manage-customer-add-member {
          top: 9px;
          right: 12px;
          z-index: 2;
        }
        .manage-customer-members-table {
          border: 1px solid #dee2e6;
          border-radius: 12px;
          overflow: hidden;
        }
        .manage-customer-members-table .rdt_TableWrapper {
          overflow-x: auto;
        }
        .manage-customer-members-table .rdt_Table {
          min-width: 1180px;
        }
        .manage-customer-members-table .rdt_TableHeadRow {
          border-bottom: 1px solid #d7dee5 !important;
        }
        .manage-customer-members-table .rdt_TableRow {
          border-bottom: 1px solid #dee2e6 !important;
        }
        .manage-customer-members-table .rdt_TableRow:last-child {
          border-bottom: 1px solid #dee2e6 !important;
        }
        .manage-customer-members-table .rdt_TableCell,
        .manage-customer-members-table .rdt_TableCol {
          border-right: 0 !important;
          box-sizing: border-box;
          min-width: 0;
        }
        .manage-customer-members-table .rdt_TableCell > *,
        .manage-customer-members-table .rdt_TableCol > * {
          max-width: 100%;
        }
        .manage-customer-members-table .customActionDropdownMenu.show {
          min-height: 92px;
          overflow: visible !important;
          z-index: 1055;
        }
        .manage-customer-members-table .customActionDropdownMenu li,
        .manage-customer-members-table .customActionDropdownMenu .dropdown-item {
          display: block !important;
          width: 100%;
        }
        .manage-customer-members-table .customActionDropdownMenu .text-danger {
          color: #e35252 !important;
        }
      `}</style>
    </div>
  );
};

export default ManageCustomer;
